import { useState } from "react";
import PropTypes from "prop-types";
import { Card, CardContent, Checkbox, Switch } from "@mui/material";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import MDTypography from "components/MDTypography";

const SearchBar = ({ onSearchChange }) => {
  const [description, setDescription] = useState("");
  const [state, setState] = useState(["Todo"]);

  const options = [    
    "Todo",
    "Nuevo",
    "En revisión",
    "Cargo aceptado",
    "Pericia propuesta",
    "Pericia acordada",
    "Informe en proceso",
    "Informe enviado",
    "Intimación actora",
    "Intimación demandada",
    "Cargo destituido",
    "Solicitud impugnación",
    "Pericia desistida",
    "Apelación",
    "Sentencia",
    "Cobrado",
  ];

  const searchFilters = () => {
    onSearchChange({ description, state: state[0] === "Todo" ? "" : state });
  };

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };  
  
   const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePendingState = (value) => {
    if (value) {
      setState([
        "Nuevo",
        "En revisión",
        "Cargo aceptado",
        "Informe en proceso",
        "Intimación actora",
        "Intimación demandada",
        "Sentencia",
      ]);
    } else {
      setState([]);
    }
  }

  const handleToggle = (option) => {
    if (option === "Todo") {
      // Si "Todo" está seleccionado, se deselecciona todo. Si no, se seleccionan todas las opciones.
      setState((prevSelected) =>
        prevSelected.includes("Todo") ? [] : [...options]
      );
    } else {
      setState((prevSelected) => {
        let newSelected = prevSelected.includes(option)
          ? prevSelected.filter((item) => item !== option) // Si está seleccionado, se deselecciona
          : [...prevSelected, option]; // Si no está seleccionado, se agrega
  
        // Si todas las opciones excepto "Todo" están seleccionadas, agregar "Todo"
        if (newSelected.length === options.length - 1 && !newSelected.includes("Todo")) {
          newSelected.push("Todo");
        }
  
        // Si "Todo" está seleccionado y se deselecciona una opción, quitar "Todo"
        if (newSelected.includes("Todo") && newSelected.length !== options.length) {
          newSelected = newSelected.filter((item) => item !== "Todo");
        }
  
        return newSelected;
      });
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      searchFilters();
    }
  };

  return (
      <Card>
        <CardContent>
          {/* <MDBox component="li" display="flex" flexWrap="wrap" alignItems="center" mb={-2}> */}
            <MDBox display="flex" alignItems="center" mb={-2}>
              <MDBox component="li" display="flex" alignItems="center" flexWrap="wrap">
                <MDBox p={1} pl={0} display="flex">
                  {/* text */}
                  <MDBox pr={1}>
                    <MDInput
                      type="text"
                      label="Texto a buscar"
                      value={description}
                      onKeyDown={handleKeyDown}
                      onChange={(event) => {
                        setDescription(event.target.value);
                      }}
                    />
                  </MDBox>
                </MDBox>
                <MDBox p={1} pl={0} display="flex">
                  {/* menu y boton */}
                  <MDBox pr={2}>
                    <MDButton
                      color="info"
                      variant="outlined"
                      disableElevation
                      onClick={handleClick}
                      endIcon={<KeyboardArrowDownIcon />}
                    >
                      {"Estado"}
                    </MDButton>
                    <Menu
                      id="basic-menu"
                      anchorEl={anchorEl}
                      open={open}
                      onClose={handleClose}
                      MenuListProps={{
                        "aria-labelledby": "basic-button",
                      }}
                    >
                      {options.map((option) => (
                        <MenuItem key={option} onClick={() => handleToggle(option)}>
                          <Checkbox checked={state.includes(option)} sx={{ py: 0, pl: 0 }} />{" "}
                          {option}
                        </MenuItem>
                      ))}
                    </Menu>
                  </MDBox>

                  <MDBox pr={1}>
                    <MDButton variant="gradient" color="info" onClick={searchFilters}>
                      Buscar
                    </MDButton>
                  </MDBox>
                </MDBox>
                <MDBox p={1} pl={0} display="flex" alignItems="center">
                  {/* switch */}
                  <MDBox mt={0.5}>
                    <Switch onChange={(e) => handlePendingState(e.target.checked)} />
                  </MDBox>
                  <MDBox width="80%" ml={0.5}>
                    <MDTypography variant="button" fontWeight="regular" color="text">
                      Filtrar pendientes
                    </MDTypography>
                  </MDBox>
                </MDBox>
              </MDBox>
            </MDBox>
          {/* </MDBox> */}
        </CardContent>
      </Card>
  );
};

SearchBar.propTypes = {
  onSearchChange: PropTypes.func,
};

export default SearchBar;
